import UnitActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperUnit:null,
  errorInternal:false
};

function UnitReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case UnitActions.RESET_LIST:
      return INITIAL_STATE;
    case UnitActions.NEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case UnitActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case UnitActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case UnitActions.RESET_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case UnitActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case UnitActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case UnitActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case UnitActions.SUCCESS_DATA:
      return { ...state, errorInternal:false,isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case UnitActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case UnitActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case UnitActions.GET_HELPER_UNIT:
      return { ...state, errorInternal:false,isError: false,isSuccess:false,onSubmit:false,helperUnit:action.payload};
    case UnitActions.ERROR_SERVER:
      return { ...state, onSubmit:false,  isError: false, errorInternal:true,  errorMessage: action.payload, isProcessing:false };
        
    default:
      return state;
    }
}

export default UnitReducer;
